import React from 'react';
import { ControlLink, Stack, Text } from '@moda/om';
import { PaymentSource } from '../../constants';
import { useCart, useCartItems } from '../../hooks/useCart';
import { isApplePaySupported } from '../../lib/apple/isApplePaySupported';
import { hrefFor } from '../../routers';
import { useCountry } from '../CountrySelector';
import { CheckoutAmazonPayButton } from './CheckoutAmazonPayButton';
import { CheckoutPayPalButton } from './CheckoutPayPalButton';
import { CheckoutApplePayButton } from './CheckoutApplePayButton';

import './CheckoutPaymentSources.scss';

export const CheckoutPaymentSources: React.FC = () => {
  const {
    cart: {
      attributes: {
        paymentSource,
        paymentSummary: { payToday }
      }
    }
  } = useCart();
  const {
    country: { currencyCode }
  } = useCountry();
  const { availableNowItems, preorderItems } = useCartItems();

  const showApplePayButton = availableNowItems.length > 0 && preorderItems.length <= 0;

  const allowApplePay = isApplePaySupported() && Number(payToday.price) > 0 && showApplePayButton;

  if (paymentSource === PaymentSource.PayPal && currencyCode !== 'USD' && !allowApplePay)
    return null;

  return (
    <div className="CheckoutPaymentSources">
      <Text>You can also checkout with</Text>
      <Stack space={2} direction="horizontal" alignItems="center">
        {paymentSource !== PaymentSource.PayPal && <CheckoutPayPalButton size="small" />}
        {paymentSource !== PaymentSource.Apple &&
          paymentSource !== PaymentSource.BraintreeApple &&
          allowApplePay && <CheckoutApplePayButton size="small" />}
        {paymentSource !== PaymentSource.Amazon && <CheckoutAmazonPayButton size="small" />}
      </Stack>
      <Text>
        By proceeding to check out via any payment method you agree to our{' '}
        <ControlLink to={hrefFor.TermsAndConditionsPage()} underlined target="_blank">
          Terms & Conditions
        </ControlLink>{' '}
        and{' '}
        <ControlLink to={hrefFor.PrivacyPolicyPage()} underlined target="_blank">
          Privacy Policy
        </ControlLink>
        .
      </Text>
    </div>
  );
};
